import {
    SETTINGS_FEATURE_FLAGS_ENABLE_CONSOLIDATED_STOCK_ALLOCATION,
    SETTINGS_FEATURE_FLAGS_ENABLE_FISCAL_MARKING_CODE_VALIDATION,
    SETTINGS_FEATURE_FLAGS_GOOD_PRICE_BADGE_ENABLED,
    SETTINGS_FEATURE_FLAGS_INTAKE_GROUP_ENABLED,
    SETTINGS_FEATURE_FLAGS_PROCESS_RECEIPTS_ASYNC_ENABLED,
    SETTINGS_FEATURE_FLAGS_PROMO_ON_PDP,
} from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsFeatureFlags = () =>
    useSettingsFactory({
        consolidatedStockAllocationEnabled: { path: SETTINGS_FEATURE_FLAGS_ENABLE_CONSOLIDATED_STOCK_ALLOCATION },
        intakeGroupEnabled: { path: SETTINGS_FEATURE_FLAGS_INTAKE_GROUP_ENABLED },
        promoOnPDPEnabled: { path: SETTINGS_FEATURE_FLAGS_PROMO_ON_PDP },
        goodPriceBadgeEnabled: { path: SETTINGS_FEATURE_FLAGS_GOOD_PRICE_BADGE_ENABLED },
        processReceiptsAsyncEnabled: { path: SETTINGS_FEATURE_FLAGS_PROCESS_RECEIPTS_ASYNC_ENABLED },
        fiscalMarkingCodeValidationEnabled: { path: SETTINGS_FEATURE_FLAGS_ENABLE_FISCAL_MARKING_CODE_VALIDATION },
    });
